export default "__VITE_ASSET__BxAmYgeH__"